import { Directive, TemplateRef } from '@angular/core';

/**
 * Tile parameters definition for a qManage tile.
 * Captures the template of the tile parameters to be rendered in a dialog.
 */
@Directive({
    selector: '[ndtTileParametersDef]',
    standalone: false
})
export class TileParametersDefDirective {
   constructor(public templateRef: TemplateRef<never>) {}
}
